import {modules} from '../define/constants'
import {Meta} from '../define/utils/Meta'
import {slotModel} from './slotModel'

export const slotMeta = new Meta(slotModel.type, [], [], [], modules,
  undefined, undefined, slotModel.kind)
